//# sourceMappingURL=dataset.mjs.map
/// <reference types="./dataset.d.mts" />
import { CustomType as $CustomType } from "../../gleam.mjs";

export class Dataset extends $CustomType {
  constructor(colors, data, labels, title) {
    super();
    this.colors = colors;
    this.data = data;
    this.labels = labels;
    this.title = title;
  }
}
export const Dataset$Dataset = (colors, data, labels, title) =>
  new Dataset(colors, data, labels, title);
export const Dataset$isDataset = (value) => value instanceof Dataset;
export const Dataset$Dataset$colors = (value) => value.colors;
export const Dataset$Dataset$0 = (value) => value.colors;
export const Dataset$Dataset$data = (value) => value.data;
export const Dataset$Dataset$1 = (value) => value.data;
export const Dataset$Dataset$labels = (value) => value.labels;
export const Dataset$Dataset$2 = (value) => value.labels;
export const Dataset$Dataset$title = (value) => value.title;
export const Dataset$Dataset$3 = (value) => value.title;

export class Options extends $CustomType {
  constructor(stacked, chart_type) {
    super();
    this.stacked = stacked;
    this.chart_type = chart_type;
  }
}
export const Options$Options = (stacked, chart_type) =>
  new Options(stacked, chart_type);
export const Options$isOptions = (value) => value instanceof Options;
export const Options$Options$stacked = (value) => value.stacked;
export const Options$Options$0 = (value) => value.stacked;
export const Options$Options$chart_type = (value) => value.chart_type;
export const Options$Options$1 = (value) => value.chart_type;
